import {
  Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Subscription } from "rxjs";
import { Piece, PieceOptional } from "../../../models/piece";
import { PieceService } from "../../services/piece.service";
import { NotifierService } from "../../shared/notifier/notifier.service";
import { MedioEntregablesService } from "../../services/medio_entregables.service";
import { SocialNetworkService } from "../../services/social-network.service";

@Component({
  selector: "app-register-piece-dialog",
  templateUrl: "register-piece-dialog.component.html",
  styleUrls: ["./register-piece-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [PieceService, MedioEntregablesService, SocialNetworkService]
})
export class RegisterPieceDialogComponent implements OnInit, OnDestroy {
  listMedios = [];
  modalTitle = "Añadir Pieza";
  buttonText = "Agregar";
  dataPiece: PieceOptional = {};
  subscription: Subscription;
  action: string;
  summit= false;
  arrArticulos = [];
  arrRedesSociales = [];

  pieceId = 0;
  workOrderId = 0;
  workType = "";
  priceListId = 0;

  constructor(
    public dialogRef: MatDialogRef<RegisterPieceDialogComponent>,
    private notifierService: NotifierService,
    private pieceService: PieceService,
    private medioEntregablesService: MedioEntregablesService,
    private socialNetworkService: SocialNetworkService,
    private zone: NgZone,
    @Inject(MAT_DIALOG_DATA) public injected: any
  ) {

    this.socialNetworkService.getSocialNetworkList().subscribe( (result: any[]) => {
      if (result && result.length > 0) {
        this.arrRedesSociales = [...result];
      }
    }, (error) => {
      console.log("Error Redes Sociales", error);
    })

    this.medioEntregablesService.getAll().subscribe( (result) => {
      if (result && result.length > 0) {
        this.listMedios = [...result]
      }
    }, (error) => {
      console.log('Error Medios ', error)
    })

    if (this.injected) {

      // Se obtiene el WorkOrderId
      this.workOrderId = this.injected.workOrderId;

      // Se obtienen los articulos
      this.priceListId = this.injected.priceListId; 

      if (this.injected.dataPiece) {
        this.dataPiece = { ...this.injected.dataPiece }
        this.pieceId = this.dataPiece.id;
        this.arrArticulos = [];
        this.pieceService.getArticulosPorListaYMedio(this.priceListId, this.dataPiece.id_medio).subscribe( (result: any[]) => {
          if (result && result.length > 0) {
            this.arrArticulos = result;
           }else {
            this.notifierService.systemNotify({
              title: "Piezas no encontradas",
              message: "No se encontraron piezas por el medio seleccionado",
              type: "error",
            });
           }
          }, (err) => {
            this.arrArticulos = []
          });
      }

    }

  }

  ngOnInit() {
    this.handleNotify();
  }

  ngOnDestroy(): void {}

  handleNotify() {
    this.subscription = this.notifierService.behaviorNotifierObject$.subscribe(
      (message) => {
        this.zone.run(() => {
          this.action = message.action;
          if (message.action == "edit" && message.model == "piece") {
            //this.dataPiece = message.object;
            this.buttonText = "Actualizar";
            this.modalTitle = "Editar Pieza";
          } else if (message.action == "register" && message.model == "piece") {
            this.buttonText = "Agregar";
            this.modalTitle = "Agregar Pieza";
          }
        });
      }
    );
  }

  editPrice($event: any) {
    if (!this.dataPiece.id_list_price_product) {
      this.dataPiece.original_price = null;
      this.dataPiece.original_quantity = null;
      this.dataPiece.adaptations = null;
      this.dataPiece.price_per_adaptation = null;
      return;
    }

    const workType = $event.target.value;
    const articulo = this.arrArticulos.find( (e) => e.id_list_price_product == this.dataPiece.id_list_price_product );

    this.dataPiece.original_price = articulo.price_list;
    this.dataPiece.price_per_adaptation = articulo.price_adaptation_list;

  }

  setPrice($event: any) {
    const idListPrice = $event.target.value;
    //console.log(this.dataPiece)
    const articulo = this.arrArticulos.find( (e) => e.id_list_price_product == idListPrice );
    //console.log({idListPrice, articulo})
    this.dataPiece.original_price = articulo.price_list;
    this.dataPiece.price_per_adaptation = articulo.price_adaptation_list;
  }

  getOtherPieces($event: any) {
    const idMedio = $event.target.value;
    //console.log({idMedio})

    // Se limpia las variables
    this.dataPiece.id_list_price_product = null;
    this.dataPiece.original_price = null;
    this.dataPiece.original_quantity = null;
    this.dataPiece.adaptations = null;
    this.dataPiece.price_per_adaptation = null;

    this.arrArticulos = [];

    this.pieceService.getArticulosPorListaYMedio(this.priceListId, idMedio).subscribe( (result: any[]) => {
      if (result && result.length > 0) {
        this.arrArticulos = result;
       }else {
        this.notifierService.systemNotify({
          title: "Piezas no encontradas",
          message: "No se encontraron piezas por el medio seleccionado",
          type: "error",
        });
       }
      }, (err) => {
        this.arrArticulos = []
      });
  }

  close() {
    this.dialogRef.close();
  }

  savePiece() {
    
    if (!this.isFormValid()) {
      this.summit = true;
      return;
    }

    this.notifierService.systemNotify({
      title: "Espere",
      message: "Agregando pieza",
      type: "info",
    });

    const {
      year, month, id_medio, id_list_price_product, format, work_type, original_quantity, original_price, adaptations, price_per_adaptation, detail, id_social_network
    } = this.dataPiece;

    const newPiece: Piece = {
      id: 0,
      id_work_order : this.workOrderId,
      id_list_price_product,
      year,
      month,
      id_medio,
      format,
      work_type,
      original_quantity,
      original_price,
      adaptations,
      price_per_adaptation,
      detail,
      id_social_network
    }

    if (newPiece.work_type === "adaptacion") {
      newPiece.original_price = null;
      newPiece.original_quantity = null;
    }else{
      newPiece.adaptations = null;
      newPiece.price_per_adaptation = null;
    }

    this.pieceService.savePiece(newPiece).subscribe(
      (result) => {
        if (result) {
          this.notifierService.systemNotify({
            title: "Pieza agregada",
            message: "Se agregó una nueva pieza a la orden de trabajo",
            type: "success",
          });
          this.dialogRef.close({isSaved: true});
          this.summit = false;
        }
      },
      (error) => {
        let mess = error.error.message;
        this.notifierService.systemNotify({
          title: "Ha ocurrido un error",
          message: mess,
          type: "error",
        });
        this.summit = false;
      }
    );

  }

  editPiece(){
    if (!this.isFormValid()) {
      this.summit = true;
      return;
    }

    this.notifierService.systemNotify({
      title: "Espere",
      message: "Actualizando pieza",
      type: "info",
    });

    const {
      year, month, id_medio, id_list_price_product, format, work_type, original_quantity, original_price, adaptations, price_per_adaptation, detail,
      id_social_network
    } = this.dataPiece;

    const newPiece: Piece = {
      id: this.pieceId,
      id_work_order : this.workOrderId,
      id_list_price_product,
      year,
      month,
      id_medio,
      format,
      work_type,
      original_quantity,
      original_price,
      adaptations,
      price_per_adaptation,
      id_social_network,
      detail
    }

    if (newPiece.work_type === "adaptacion") {
      newPiece.original_price = null;
      newPiece.original_quantity = null;
    }else{
      newPiece.adaptations = null;
      newPiece.price_per_adaptation = null;
    }

    this.pieceService.updatePiece(this.pieceId,newPiece).subscribe(
      (result) => {
        if (result) {
          this.notifierService.systemNotify({
            title: "Pieza actualizada",
            message: "Se actualizó la pieza del orden de trabajo",
            type: "success",
          });
          this.dialogRef.close({isSaved: true})
          this.summit = false;
        }
      },
      (error) => {
        let mess = error.error.message;
        this.notifierService.systemNotify({
          title: "Ha ocurrido un error",
          message: mess,
          type: "error",
        });
        this.summit = false;
      }
    );
  }

  isFormValid(){

    const { year, month, id_medio, id_list_price_product, format, work_type, original_quantity, original_price, adaptations, price_per_adaptation } = this.dataPiece;

    let isInvalid1: boolean = (
        ( isNaN(Number(year))        || year        === null || year        === undefined ) ||
        ( isNaN(Number(month))       || month       === null || month       === undefined ) ||
        ( isNaN(Number(id_medio))       || id_medio       === null || id_medio       === undefined ) ||
        ( isNaN(Number(id_list_price_product)) || id_list_price_product === null || id_list_price_product === undefined ) ||
        ( format      === null || format      === undefined ) ||
        ( work_type   === null || work_type   === undefined )
      );

      let isInvalid2 = false;

      if (work_type === "original") {
        isInvalid2 = ( isNaN(Number(original_quantity))    || original_quantity    === null || original_quantity    === undefined) ||
                     ( isNaN(Number(original_price))       || original_price       === null || original_price       === undefined);
      }else{
        if (work_type === "adaptacion") {
          isInvalid2 = ( isNaN(Number(adaptations))          || adaptations          === null || adaptations          === undefined) ||
                       ( isNaN(Number(price_per_adaptation)) || price_per_adaptation === null || price_per_adaptation === undefined)
        } else {
          isInvalid2 = true;
        }
      }

      return !(isInvalid1 || isInvalid2);  
  }

  onlyNumbers(evt, decimal: boolean = false) {
    // keypress
    var theEvent = evt || window.event;

    if (theEvent.type === "paste") {
      key = (window.event as any).clipboardData.getData("text/plain");
    } else {
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }

    var regex = decimal ? /\d|\./ : /^\d+$/;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  handlePasteOnlyNumbers(e, decimal: boolean = false) {
    // paste
    var clipboardData, pastedData;

    clipboardData = e.clipboardData; // || window?.clipboardData;
    pastedData = clipboardData.getData("text/plain").toUpperCase();

    const regex = decimal ? /^\d+(\.\d+)?$/ : /^\d+$/;

    if (!pastedData.match(regex)) {
      return false;
    }

    if (pastedData.indexOf("E") > -1) {
      e.stopPropagation();
      e.preventDefault();
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/system/work-order/register-piece-dialog/register-piece-dialog.component.ts